import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

import StaticSmallCard from './StaticSmallCard';

class Accordeon extends React.Component {
  static propTypes = {
    related: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      toggle: 'inactive'
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {

    if (this.state.toggle === 'inactive') {
      this.setState({toggle: 'expanded'});
    } else if (this.state.toggle === 'expanded') {
      this.setState({toggle: 'inactive'});
    }

  }

  render() {
    let listRelated = this.props.related.map((item) => {
      return (
        <StaticSmallCard key={`side-` + item.id} name={item.title} price={item.price}
                         description={item.description} photo={item.photo}/>
      );
    });

    return (
      <div id="accordeon" className={`accordeon ` + this.state.toggle}>
        <div className="accordeon-title" onClick={this.handleClick}>
          <FormattedMessage id="suggested_extras">
            {(message) => <span>{message}</span>}
          </FormattedMessage>
        </div>
        <div className="accordeon-items">
          {listRelated}
        </div>
      </div>
    );
  }
}


export default Accordeon;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/Accordeon.js
 **/